function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_7838",
  "data-name": "Group 7838",
  transform: "translate(-772.084 -337.431)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7647",
  "data-name": "Group 7647",
  transform: "translate(765 337)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_tick_3923816",
  transform: "translate(7.084 0.431)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3432",
  "data-name": "Path 3432",
  d: "M18.584,2A16.584,16.584,0,1,0,35.169,18.584,16.584,16.584,0,0,0,18.584,2ZM28,15.661l-9.951,9.121a1.658,1.658,0,0,1-2.294-.05l-4.975-4.975a1.658,1.658,0,1,1,2.345-2.345l3.852,3.853,8.78-8.048A1.659,1.659,0,0,1,28,15.661Z",
  transform: "translate(-2 -2)",
  fill: "#f37320"
})), /*#__PURE__*/React.createElement("g", {
  id: "noun_Cross_2135404",
  transform: "translate(99.084 0.431)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3438",
  "data-name": "Path 3438",
  d: "M16.584,0h0A16.584,16.584,0,0,0,0,16.584H0A16.584,16.584,0,0,0,16.584,33.169h0A16.584,16.584,0,0,0,33.169,16.584h0A16.584,16.584,0,0,0,16.584,0Zm5.683,19.888c.846.8,1.141,1.74.266,2.627s-1.814.617-2.628-.221l-3.374-3.472c-1.187,1.263-2.223,2.378-3.273,3.478-.808.847-1.761,1.1-2.626.206s-.557-1.829.284-2.627c1.072-1.017,2.142-2.035,3.654-3.472-1.3-1.1-2.474-2.063-3.6-3.069-.907-.808-1.246-1.807-.267-2.734.907-.856,1.844-.505,2.628.332,1.009,1.076,2.012,2.156,3.264,3.5,1.3-1.382,2.328-2.506,3.382-3.611a1.629,1.629,0,0,1,2.512-.214c.9.858.677,1.809-.17,2.624-1.1,1.057-2.214,2.094-3.571,3.375C20.046,17.815,21.161,18.847,22.267,19.888Z",
  transform: "translate(0 0)",
  fill: "#f37320"
})), /*#__PURE__*/React.createElement("g", {
  id: "noun_Man_4326500",
  transform: "translate(22.671 53.261)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3433",
  "data-name": "Path 3433",
  d: "M11.274,20.722,12,22.89a2.115,2.115,0,0,0,2,1.449h2.22a2.115,2.115,0,0,0,2-1.449l.724-2.168L15.112,17.55Z",
  transform: "translate(32.421 78.362)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3434",
  "data-name": "Path 3434",
  d: "M10.126,17.889,20.171,27.934,30.215,17.889V13.94a24.42,24.42,0,0,1-13.032,2.035,25.8,25.8,0,0,1-7.09-1.956Z",
  transform: "translate(27.363 62.401)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3435",
  "data-name": "Path 3435",
  d: "M12.495,15a.132.132,0,0,0-.18,0L8.662,18.653l6.344,14.311a.122.122,0,0,0,.09.074.143.143,0,0,0,.111,0l8.332-6.947Z",
  transform: "translate(21.224 67.093)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3436",
  "data-name": "Path 3436",
  d: "M23.586,15.021,12.521,26.081l8.348,6.947a.116.116,0,0,0,.111,0,.1.1,0,0,0,.085-.074l2.242-5.028,4.124-9.278L23.777,15a.122.122,0,0,0-.19.026Z",
  transform: "translate(37.767 67.076)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3437",
  "data-name": "Path 3437",
  d: "M88.9,90.562,72.186,84.468a1.94,1.94,0,0,0-.46-.813l-4.557-4.7A3.775,3.775,0,0,0,64.325,77.8V73.982a25.318,25.318,0,0,0,7.93-8.3,26.827,26.827,0,0,0,2.9-6.912,27.456,27.456,0,0,0,.878-6.912c0-16.748,0-16.487-.042-17.174A1.984,1.984,0,0,0,74.9,32.967a1.87,1.87,0,0,0-1.981.2,2.011,2.011,0,0,0-.743,1.905c.042.447,0,.835,0,16.787,0,12.411-9.747,22.471-21.774,22.471S28.631,64.271,28.631,51.86c0-4.419-.045-7.763-.061-10.48a10.179,10.179,0,0,1,3.693-7.973,9.512,9.512,0,0,1,8.366-1.885c8.871,2.182,12.44,7.905,23.79,7.359a1.978,1.978,0,0,0-.18-3.95c-10.283.5-13.042-4.85-22.733-7.25a13.25,13.25,0,0,0-11.626,2.655,14.179,14.179,0,0,0-5.122,11.093c0,1.975.037,4.364.053,7.234a4.1,4.1,0,0,1-2.146-3.612V20.988A4.626,4.626,0,0,1,27.212,16.3a1.915,1.915,0,0,0,1.776-1.238A17.052,17.052,0,0,1,44.885,3.95h16.3c9.511.012,17.218,7.965,17.23,17.78V45.052a1.915,1.915,0,1,0,3.828,0V21.729C82.232,9.735,72.813.015,61.19,0h-16.3A20.8,20.8,0,0,0,25.911,12.45a8.579,8.579,0,0,0-7.09,8.538V45.052a8.02,8.02,0,0,0,6.016,7.812c.053,0,.132,1.9.153,2.089q.122,1.047.317,2.079A26.57,26.57,0,0,0,35.887,73.65c.28.2.592.344.883.546V77.84A3.78,3.78,0,0,0,33.921,79l-4.557,4.7a1.93,1.93,0,0,0-.46.818L14.666,89.694l-3.7,1.424A14.287,14.287,0,0,0,3.009,104V129.04a1.884,1.884,0,0,0,1.85,1.716,1.884,1.884,0,0,0,1.85-1.716V104a10.716,10.716,0,0,1,.65-3.661l9.4,8.282a6.354,6.354,0,0,1,2.115,4.768v15.619a1.941,1.941,0,0,0,.863,1.832,1.812,1.812,0,0,0,1.974,0,1.941,1.941,0,0,0,.863-1.832V113.388a10.252,10.252,0,0,0-3.421-7.681L9.306,96.994a10.03,10.03,0,0,1,4.1-2.815l16.569-6.034,5.863,13.639a3.843,3.843,0,0,0,2.643,2.253,3.7,3.7,0,0,0,3.336-.813l1.8-1.555.264.818a6.07,6.07,0,0,0,1.628,2.564L41.7,128.718a1.914,1.914,0,0,0,1.528,2.182,2,2,0,0,0,.307,0,1.884,1.884,0,0,0,1.835-1.6l3.664-22.76h2.976l3.7,22.76a1.874,1.874,0,0,0,1.829,1.6,1.937,1.937,0,0,0,.307,0,1.909,1.909,0,0,0,1.528-2.182l-3.833-23.661a6.02,6.02,0,0,0,1.639-2.57l.259-.813,1.808,1.549a3.716,3.716,0,0,0,2.448.922,3.845,3.845,0,0,0,3.526-2.357l2.2-5.112h0l.619-1.429h0l3.019-7.092,16.6,6.05a10.03,10.03,0,0,1,4.092,2.81l-9.849,8.729a10.241,10.241,0,0,0-3.426,7.681v15.619a1.941,1.941,0,0,0,.863,1.832,1.812,1.812,0,0,0,1.974,0,1.941,1.941,0,0,0,.863-1.832V113.393a6.371,6.371,0,0,1,2.115-4.768l9.4-8.309a10.57,10.57,0,0,1,.65,3.661v25.035a1.941,1.941,0,0,0,.863,1.832,1.812,1.812,0,0,0,1.974,0,1.941,1.941,0,0,0,.863-1.832V103.977A14.223,14.223,0,0,0,88.9,90.562ZM54.973,77.889a24.679,24.679,0,0,0,5.636-1.844V80.12L50.542,90.507,40.5,80.142V76.154a25.18,25.18,0,0,0,7.09,2.019,24.382,24.382,0,0,0,7.386-.273ZM39.44,100.262a.139.139,0,0,1-.111,0,.123.123,0,0,1-.09-.076L32.9,85.417l3.653-3.77a.129.129,0,0,1,.18,0l11.06,11.418Zm14.2.993a2.122,2.122,0,0,1-2,1.495h-2.22a2.122,2.122,0,0,1-2-1.495l-.724-2.237,3.838-3.273,3.838,3.273Zm10.415-6.23-2.242,5.188a.1.1,0,0,1-.085.076.113.113,0,0,1-.111,0L53.281,93.12,64.346,81.707a.119.119,0,0,1,.18,0l3.653,3.77Z",
  transform: "translate(-3.009 0)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_8487",
  "data-name": "Group 8487",
  transform: "translate(-0.081 0.498)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4122",
  "data-name": "Path 4122",
  d: "M55.165,16.584h28.1s.83-9.848-9.8-13.81-17.086,7.307-17.157,8.172",
  fill: "none",
  stroke: "#f37321",
  strokeLinecap: "round",
  strokeWidth: 3.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4123",
  "data-name": "Path 4123",
  d: "M56.673,22s2.539,9.037,12.485,8.866A14.991,14.991,0,0,0,82.569,22",
  fill: "none",
  stroke: "#f37321",
  strokeLinecap: "round",
  strokeWidth: 3.5
}))));

function SvgStepper3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125.169,
    height: 184,
    viewBox: "0 0 125.169 184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper3);
export default __webpack_public_path__ + "static/media/stepper3.c5b327f26102db2d355fa8b7f77eac85.svg";
export { ForwardRef as ReactComponent };